export default {
    methods: {
        hasPermission(permission) {
            if (permission === 'noCheck')
                return true;
            if (this.$store.get('login/userInfo').is_admin == 1)
                return true;
            else if (this.$store.get('login/userInfo').permissions.includes(permission))
                return true;
            else
                return false;
        }
    }
}